import chevron from '@/services/chevron';

const getLoginUrl = (): string => {
  const mainAppUrl = import.meta.env.VITE_API_MAIN_APP;
  const currentUrl = window.location.href;
  const returnUrl = encodeURIComponent(currentUrl);
  return `${mainAppUrl}/login?nextUri=${returnUrl}`;
};

/**
 * Validates user authentication for the app.
 * Returns true if authenticated, redirects to login otherwise.
 *
 * TODO: Create auth util file
 */
export const validateAuth = async (): Promise<boolean> => {
  try {
    const session = await chevron.validateSession();

    if (session) {
      return true;
    }

    window.location.href = getLoginUrl();
    return false;
  } catch {
    console.error('Auth validation failed:');
    window.location.href = getLoginUrl();
    return false;
  }
};
